export const OPACITY_0 = { opacity: 0 };
export const OPACITY_1 = { opacity: 1 };
export const DURATION_1 = { duration: 1 };
export const DURATION_2 = { duration: 2 };
export const FADE_OUT_LEFT = { ...OPACITY_0, x: -300 };
export const FADE_OUT_TOP = { ...OPACITY_0, y: -200 };
